function Services() {
  const services = [
    {
      icon: "ri-smartphone-line",
      title: "アプリ開発",
      description:
        "要件定義から設計、実装、テストまで一貫して対応。iOS・Android両対応のネイティブアプリやクロスプラットフォーム開発で、ユーザー体験を重視したアプリケーションを提供します。",
    },
    {
      icon: "ri-code-s-slash-line",
      title: "Webサイト制作",
      description:
        "レスポンシブ対応、SEO最適化を標準実装。モダンなデザインと高速なパフォーマンスを両立し、コンバージョンを最大化するWebサイトを構築します。CMSの導入も可能です。",
    },
    {
      icon: "ri-settings-3-line",
      title: "保守運用",
      description:
        "セキュリティ更新、パフォーマンス監視、バグ修正など継続的なサポートを提供。定期的なレポートと改善提案で、システムの安定稼働と進化をサポートします。",
    },
  ];

  return (
    <section
      id="services"
      className="relative overflow-hidden bg-red-50 px-6 py-16 md:px-12 md:py-24 lg:px-24"
    >
      <div className="relative z-10 mx-auto max-w-7xl">
        <div className="fade-in-section mb-12 flex items-center gap-6 md:mb-16 md:gap-8">
          <div>
            <h2 className="mb-3 text-4xl font-semibold text-gray-900 md:mb-4 md:text-6xl">
              <span className="text-red-500">S</span>ervices
            </h2>
            <p className="text-gray-600">サービス</p>
          </div>
          <div className="h-px flex-1 bg-gradient-to-r from-gray-300 to-transparent"></div>
        </div>
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-10 lg:grid-cols-3">
          {services.map((service, index) => (
            <div
              key={index}
              className="fade-in-section rounded-2xl border-2 border-gray-200 bg-white p-8 shadow-lg transition-all duration-300 md:p-12"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-50">
                <i className={`${service.icon} text-3xl text-red-500`}></i>
              </div>
              <h3 className="mb-4 text-center text-2xl font-semibold text-gray-900">
                {service.title}
              </h3>
              <p className="text-sm leading-relaxed text-gray-600">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
